function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { makeNetTerms } from "../../infra/translator";
import { AgreementChangeType } from "./model";
export function makeNetTermsChange(netTerms) {
  return {
    type: AgreementChangeType.NetTerms,
    value: {
      netTerms: makeNetTerms(netTerms)
    }
  };
}
export function makeLegalTermsChange(legalTermsDocuments) {
  return {
    type: AgreementChangeType.legalTermsDocuments,
    value: {
      legalTermsDocuments: legalTermsDocuments.map(lt => {
        var _lt$contentOverride;
        return _objectSpread({
          legalTermsId: lt.legalTermsId
        }, lt.type === 'quill' ? {
          contentOverride: (_lt$contentOverride = lt.contentOverride) !== null && _lt$contentOverride !== void 0 ? _lt$contentOverride : {
            type: 'none'
          }
        } : {});
      })
    }
  };
}
export function makeAmendmentsApprovalMethodChange(amendmentsApprovalMethod) {
  return {
    type: AgreementChangeType.AmendmentsApprovalMethod,
    value: {
      amendmentsApprovalMethod
    }
  };
}
export function makeInvoicesApprovalMethodChange(invoicesApprovalMethod) {
  return {
    type: AgreementChangeType.InvoicesApprovalMethod,
    value: {
      invoicesApprovalMethod
    }
  };
}
export function makeServicesChange(services) {
  return {
    type: AgreementChangeType.Services,
    value: {
      services
    }
  };
}
export function makeTitleChange(title) {
  return {
    type: AgreementChangeType.Title,
    value: {
      title
    }
  };
}
export function makeManualPaymentsChange(allowManualPayments) {
  return {
    type: AgreementChangeType.ManualPayments,
    value: {
      allowManualPayments
    }
  };
}
export function makeCoverCreditCardFeesChange(coverCreditCardFees) {
  return {
    type: AgreementChangeType.CoverCreditCardFees,
    value: {
      coverCreditCardFees
    }
  };
}
export function makeSellerChange(seller) {
  return {
    type: AgreementChangeType.Seller,
    value: {
      seller
    }
  };
}
export function makeServiceQboClassChange(serviceId, classBefore, classAfter) {
  return {
    type: AgreementChangeType.ServiceQboClass,
    value: {
      serviceId,
      integratedClass: {
        before: classBefore,
        after: classAfter
      }
    }
  };
}